import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { CssVarsTheme, defaults } from './branding';

@Injectable({
   providedIn: 'root',
})
export class ThemeService {
   get currentTheme() { return this.themeChange$.getValue(); }

   themeChange$: BehaviorSubject<CssVarsTheme> = new BehaviorSubject( defaults );
}
